'use client'
import { Skeleton } from '@morpho-org/ui-v6/server'

const VaultSimpleActionPanelLoading = () => {
  return (
    <div className="gap-sm flex grow basis-[100%] flex-col">
      <div className="gap-2xs flex items-center">
        <Skeleton className="h-lg w-[73px] rounded-lg" />
        <Skeleton className="h-lg w-[82px] rounded-lg" />
      </div>
      <Skeleton className="h-[144px] w-[100%] rounded-[20px]" />
      <Skeleton className="h-[188px] w-[100%] rounded-[20px]" />
      <Skeleton className="h-[48px] w-[100%] rounded-[20px]" />
    </div>
  )
}

export default VaultSimpleActionPanelLoading
